import React from "react";
import { ProgressBar } from "react-bootstrap";

export function ModalProgressBar({variant = "success"}) {

  return (
    <ProgressBar
      variant={variant}
      animated
      now={100}
      className="h-5px align-self-center"
      style={{  width: "97%" }}
    />
  );
}
